<template>
  <Transition name="modal">
    <div v-if="showModalMain" class="lgpd-accept" id="modalLgpdAccept">
      <div class="lgpd-accept">
        <div class="lgpd-accept-div">
          <div class="lgpd-accept-div-left">
            {{ translate.modalAcceptText1 }}
            <span class="lgpd-accept-manager" @click="openLgpdModal()">{{
              translate.modalAcceptText2
            }}</span>
          </div>
          <div class="lgpd-accept-div-right">
            <input
              type="button"
              class="lgpd-accept-btn-allow"
              :value="translate.modalAcceptButton1"
              @click="saveLgpdCookie()"
            />
            <input
              type="button"
              class="lgpd-accept-btn-not-allow"
              :value="translate.modalAcceptButton2"
              @click="openLgpdModal()"
            />
          </div>
        </div>
      </div>
    </div>
  </Transition>

  <Transition name="details">
    <div v-if="showModalDetails" class="modal-mask-details">
      <div class="lgpd-modal">
        <div class="lgpd-modal-top">
          <img
            src="https://api.belladasemana.com.br/assets/img/logo-menu.png"
            alt="Logo"
            style="width: 280px"
          />
          <img
            src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
            alt="Close"
            @click="closeModal()"
            class="close-modal"
          />
        </div>
        <hr style="color: #ffffff" />
        <div class="lgpd-modal-middle">
          <p class="lgpd-modal-text-1">{{ translate.modalManagerTitle1 }}</p>
          <p class="lgpd-modal-text-3">{{ translate.modalManagerText1 }}</p>
          <p class="lgpd-modal-text-1">{{ translate.modalManagerTitle2 }}</p>
          <p class="lgpd-modal-text-3">{{ translate.modalManagerText2 }}</p>
          <p class="lgpd-modal-text-1">{{ translate.modalManagerTitle3 }}</p>
          <p class="lgpd-modal-text-3">{{ translate.modalManagerText3 }}</p>
          <input
            type="button"
            class="lgpd-accept-btn-allow"
            :value="translate.modalAcceptButton1"
            @click="saveLgpdCookie()"
          />
          <br /><br />
          <p class="lgpd-modal-text-1">{{ translate.modalManagerTitle4 }}</p>
          <div style="display: flex; width: 100%">
            <div style="width: 75%">
              <p class="lgpd-modal-text-2">
                {{ translate.modalManagerSubtitle1 }}
              </p>
            </div>
            <div style="width: 25%; text-align: right">
              <p style="color: #6ca727" class="lgpd-modal-text-2">
                {{ translate.modalManagerActive }}
              </p>
            </div>
          </div>
          <p class="lgpd-modal-text-3">{{ translate.modalManagerSubtext1 }}</p>
          <div style="display: flex; width: 100%">
            <div style="width: 80%">
              <p class="lgpd-modal-text-2">
                {{ translate.modalManagerSubtitle2 }}
              </p>
            </div>
            <div style="width: 20%; text-align: right">
              <label class="toggleswitch-switch">
                <input
                  type="checkbox"
                  name="cookie-functionality"
                  id="cookie-functionality"
                  checked
                />
                <span class="toggleswitch-slider toggleswitch-round"></span>
              </label>
            </div>
          </div>
          <p class="lgpd-modal-text-3">{{ translate.modalManagerSubtext2 }}</p>
          <div style="display: flex; width: 100%">
            <div style="width: 80%">
              <p class="lgpd-modal-text-2">
                {{ translate.modalManagerSubtitle3 }}
              </p>
            </div>
            <div style="width: 20%; text-align: right">
              <label class="toggleswitch-switch">
                <input
                  type="checkbox"
                  name="cookie-publicity"
                  id="cookie-publicity"
                  checked
                />
                <span class="toggleswitch-slider toggleswitch-round"></span>
              </label>
            </div>
          </div>
          <p class="lgpd-modal-text-3">{{ translate.modalManagerSubtext3 }}</p>
        </div>
        <hr style="color: #ffffff" />
        <div class="lgpd-modal-bottom">
          <input
            type="button"
            class="lgpd-accept-btn-allow"
            :value="translate.modalManagerSave"
            @click="saveLgpdCookie()"
          />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import acceptTradutor from "@/tradutors/acceptcookies";
import { useCookies } from "vue3-cookies";

const showModalMain = ref(false);
const showModalDetails = ref(false);
const { cookies } = useCookies();

onMounted(() => {
  if (
    !cookies.isKey("acceptCookie") &&
    document.getElementById("modalPromoMain") == null &&
    document.getElementById("modalPromoFooter") == null &&
    document.getElementById("modalSubscribeExit") == null &&
    document.getElementById("modalLegalWarning") == null &&
    document.getElementById("modalBannerPlanUnique") == null &&
    document.getElementById("modalNotification") == null &&
    document.getElementById("modalLgpdAccept") == null &&
    document.getElementById("modalNewsletter") == null
  ) {
    showModalMain.value = true;
  }
});

function saveLgpdCookie() {
  var cookieFunctionality = true;
  var cookiePublicity = true;
  const funcElement = document.getElementById(
    "cookie-functionality"
  ) as HTMLInputElement;
  const pubElement = document.getElementById(
    "cookie-publicity"
  ) as HTMLInputElement;
  if (funcElement) {
    cookieFunctionality = funcElement.checked;
  }
  if (pubElement) {
    cookiePublicity = pubElement.checked;
  }
  var days365 = 1000 * 60 * 60 * 24 * 365;
  cookies.set("acceptCookie", "true", days365);
  cookies.set(
    "acceptCookieFunctionality",
    String(cookieFunctionality),
    days365
  );
  cookies.set("acceptCookiePublicity", String(cookiePublicity), days365);
  showModalDetails.value = false;
  showModalMain.value = false;
}
function openLgpdModal() {
  showModalDetails.value = true;
}
function closeModal() {
  showModalDetails.value = false;
}

const route = useRoute();

const translate = computed(() =>
  route.params.language === "pt-br"
    ? acceptTradutor.portugues
    : acceptTradutor.ingles
);
</script>

<style scoped>
hr {
  margin-top: 0px;
  margin-bottom: 0px;
}
.modal-mask-details {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}

.lgpd-accept {
  left: 50%;
  transform: translate(-50%);
  /* mantém o banner dentro da viewport (90%) até a largura de projeto (1540px),
     evitando o estouro horizontal em telas menores que 1540px */
  width: 90vw;
  max-width: 1540px;
  height: auto;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  position: fixed;
  bottom: 10px;
  font-family: "Exo 2";
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  display: flex;
  z-index: 999;
  animation-duration: 1s;
  animation-name: slidein;
  font-family: "Roboto-Regular";
}

@keyframes slidein {
  from {
    margin-left: 100%;
  }

  to {
    margin-left: 0%;
  }
}
.lgpd-accept-div {
  display: flex;
  position: relative;
  max-width: 1440px;
}

.lgpd-accept-div-left {
  line-height: 1.3;
  width: 60%;
  padding: 15px 20px 15px 10px;
  font-size: 10px;
  color: black;
  text-align: justify;
  font-weight: 100;
}

.lgpd-accept-div-right {
  display: flex;
  width: 55%;
  justify-content: space-around;
  align-items: center;
}

.lgpd-accept-div-right input {
  width: 45%;
}

.lgpd-accept-btn-allow {
  background-color: #000000;
  border: 0px;
  padding: 5px 30px;
  border-radius: 10px;
  color: #ffffff;
  font-size: 13px;
  cursor: pointer;
}

.lgpd-accept-btn-not-allow {
  background-color: #f2f2f2;
  border: 0px;
  padding: 5px 30px;
  border-radius: 10px;
  color: #1d1d1d;
  font-size: 13px;
  cursor: pointer;
}

.lgpd-accept-manager {
  color: #b20000;
  cursor: pointer;
}

.lgpd-modal {
  position: fixed;
  width: 600px;
  background-color: #fff;
  border: 1px solid #bbb;
  text-align: center;
  border-radius: 10px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: "Roboto-Regular";
}

.lgpd-modal-top {
  text-align: left;
  padding-left: 20px;
  padding-top: 10px;
}

.lgpd-modal-middle {
  text-align: left;
  padding: 0 25px 0 25px;
  overflow-y: scroll;
  height: 550px;
}

.lgpd-modal-bottom {
  padding: 20px;
  text-align: right;
}

.lgpd-modal-text-1 {
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0 10px 0;
}

.lgpd-modal-text-2 {
  font-size: 14px;
  font-weight: bold;
}

.lgpd-modal-text-3 {
  font-size: 13px;
  text-align: justify;
  font-weight: 100;
}

.toggleswitch-switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.toggleswitch-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.toggleswitch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #b20000;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.toggleswitch-slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .toggleswitch-slider {
  background-color: #6ca727;
}

input:focus + .toggleswitch-slider {
  box-shadow: 0 0 1px #6ca727;
}

input:checked + .toggleswitch-slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.toggleswitch-slider.toggleswitch-round {
  border-radius: 34px;
}

.toggleswitch-slider.toggleswitch-round:before {
  border-radius: 50%;
}

.close-modal {
  cursor: pointer;
  position: absolute;
  left: 94.6%;
  top: 8px;
}

@media screen and (max-width: 980px) {
  .lgpd-accept-div {
    display: block;
  }

  .lgpd-accept-div-right {
    display: block;
    margin-bottom: 30px;
  }

  .lgpd-accept-div-right input {
    width: 100%;
    margin: 10px;
  }

  .lgpd-accept-div-left {
    width: 100%;
    padding: 10px;
  }
  .lgpd-accept-div-right {
    width: 95%;
  }
}

@media screen and (max-width: 650px) {
  .lgpd-accept-div {
    display: block;
  }

  .lgpd-accept-div-right {
    display: block;
    margin-bottom: 10px;
  }

  .lgpd-accept-div-right input {
    width: 100%;
    margin: 5px;
  }
  .lgpd-modal {
    width: 95%;
  }
  .close-modal {
    left: 91.6%;
    width: 25px;
    height: 25px;
  }
  .lgpd-modal-text-1,
  .lgpd-modal-text-3 {
    font-size: 12px;
    line-height: 1.2;
  }
  .lgpd-accept {
    width: 340px;
  }
}
</style>
